export default "__VITE_ASSET__Ckqo_dhN__"